import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=04528cd9&scoped=true&"
import script from "@/scripts/Dashboard/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Dashboard/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04528cd9",
  null
  
)

export default component.exports